import { render, staticRenderFns } from "./CollectionDepartmentPerformanceLock.vue?vue&type=template&id=137ca6ce&scoped=true&"
import script from "./CollectionDepartmentPerformanceLock.vue?vue&type=script&lang=js&"
export * from "./CollectionDepartmentPerformanceLock.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDepartmentPerformanceLock.vue?vue&type=style&index=0&id=137ca6ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137ca6ce",
  null
  
)

export default component.exports